import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { I18nService, SupportedLanguage } from '../../../services/i18n.service';
import { TranslatePipe } from '../../../pipes/translate.pipe';

interface LanguageOption {
  code: SupportedLanguage;
  name: string;
  flag: string;
}

@Component({
  selector: 'app-language-switcher',
  standalone: true,
  imports: [CommonModule, TranslatePipe],
  template: `
    <div class="language-switcher">
      <div class="selected-language" (click)="toggleDropdown()">
        <span class="flag">{{ getFlag(currentLang) }}</span>
        <span class="language-name">{{ getLanguageName(currentLang) }}</span>
        <i class="fas fa-chevron-down"></i>
      </div>
      <div class="language-dropdown" *ngIf="isDropdownOpen">
        <div class="language-option"
             *ngFor="let lang of languages"
             (click)="selectLanguage(lang.code)">
          <span class="flag">{{ lang.flag }}</span>
          <span class="language-name">{{ lang.name }}</span>
        </div>
      </div>
    </div>
  `,
  styleUrls: ['./language-switcher.component.scss']
})
export class LanguageSwitcherComponent implements OnInit {
  currentLang: SupportedLanguage = 'zh-TW';
  isDropdownOpen = false;

  languages: LanguageOption[] = [
    { code: 'zh-TW', name: '繁體中文', flag: '🇹🇼' },
    { code: 'en-US', name: 'English', flag: '🇺🇸' },
    { code: 'ja-JP', name: '日本語', flag: '🇯🇵' },
    // { code: 'th-TH', name: 'ไทย', flag: '🇹🇭' },
    // { code: 'id-ID', name: 'Bahasa Indonesia', flag: '🇮🇩' }
  ];

  constructor(private i18nService: I18nService) {}

  ngOnInit(): void {
    this.i18nService.currentLang.subscribe(lang => {
      this.currentLang = lang;
    });
  }

  toggleDropdown(): void {
    this.isDropdownOpen = !this.isDropdownOpen;
  }

  selectLanguage(lang: SupportedLanguage): void {
    this.i18nService.setLanguage(lang);
    this.isDropdownOpen = false;
  }

  getLanguageName(code: SupportedLanguage): string {
    const language = this.languages.find(lang => lang.code === code);
    return language ? language.name : '';
  }

  getFlag(code: SupportedLanguage): string {
    const language = this.languages.find(lang => lang.code === code);
    return language ? language.flag : '';
  }
}
